import { OverviewState, useOverviewLinkState } from '../linkstate/pricingTaxiOverview.linkstate';

export const useZoneTimePricingTaxiOverviewLinkStateActions = () => {
    const [state, setState] = useOverviewLinkState();
    return {
        patch: (patch: Partial<OverviewState>) => setState({ ...state, ...patch }),
    };
};
